var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex w-full bg-gray-50 md:px-4 h-full md:h-auto",attrs:{"id":"layout"}},[_c('div',{staticClass:"form-box bg-gray-100 rounded-3xl overflow-auto mx-auto py-30 md:py-20"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }